$(document).ready(function() {
  // $(document).on("click",".template-collection button.header__mobile-nav-toggle",function(){
  //   if($(this).attr("aria-expanded")!="true")
  //   {
  //     alert(0);
  //     $(".mobile-menu").addClass("open");
  //     $(this).attr("aria-expanded","true");
  //   }
  //   else
  //   {
  //     alert(1);
  //     $(".mobile-menu").removeClass("open");
  //     $(this).attr("aria-expanded","false");
  //   }
     
  // });
    $('#review-carousel').owlCarousel({
        // margin:30,
        // loop:true,
        slideSpeed: 5000,
        paginationSpeed: 400,
        // autoplay:true,
        nav: false,
        pagination: false,
        dots: true,
        navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
        responsive: {
            0: {
                items: 1
            },
            480: {
                items: 1
            },
            700: {
                items: 1
            },
            1000: {
                items: 3
            },
            1100: {
                items: 3
            }
        }
    });
    //   $('.main-carousel').flickity({
    //   options
    //   cellAlign: 'left',
    //   contain: true,
    //     groupCells: '100%',
    //     prevNextButtons: false,
    //     autoPlay: true
    // });
});
setTimeout(function() {
    jQuery(".line-item__meta").each(function() {
        var line_item = $(this).find(".line-item__title").text().trim();
        if (line_item == "Front Line Shipping") {
            $("#cinput").attr("checked", "checked");
        }
    });
}, 1000);
jQuery(document).on("change", "#cinput", function() {
    if ($(this).is(':checked')) {
        var quantity = 1;
        quantity = parseInt(quantity);
       
        var id = "45141092925737";
        $.ajax({
            type: 'POST',
            url: document.location.origin + '/cart/add.js',
            dataType: 'json',
            data: {
                id: id,
                quantity: quantity
            },
            success: function() {
                location.href = "/cart";
                
            }
        });
    } else {
        var quantity = 0;
        quantity = parseInt(quantity);
        var id = "45141092925737";
        $.ajax({
            type: 'POST',
            url: document.location.origin + '/cart/change.js',
            dataType: 'json',
            data: {
                id: id,
                quantity: quantity
            },
            success: function() {
                location.href = "/cart";
            }
        });
    }
});

/*Load More Button JS*/
$('.js-load-more').on('click', function() {
    var $this = $(this),
        totalPages = parseInt($('[data-total-pages]').val()),
        currentPage = parseInt($('[data-current-page]').val());
    $this.attr('disabled', true);
    $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide');
    currentPage = currentPage + 1;
    var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + currentPage);
    $('[data-current-page]').val(currentPage);
    $.ajax({
        url: nextUrl,
        type: 'GET',
        dataType: 'html',
        success: function(responseHTML) {
            $('.collection__dynamic-part .product-list').append($(responseHTML).find('.collection__dynamic-part .product-list').html());
        },
        complete: function() {
            if (currentPage < totalPages) {
                $this.attr('disabled', false);
                $this.find('[load-more-text]').removeClass('hide');
                $this.find('[loader]').addClass('hide');
            } else {
                $(".load-more_wrap").addClass('hide');
            }
        }
    })
});
/*Load More Button JS End*/